import { TrendingUp, Activity } from 'lucide-react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  BarChart, Bar,
} from 'recharts';

const AMBER = '#D97706';
const GREEN = '#4C735B';

const ChartTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-stone-200 rounded-xl px-4 py-2.5 shadow-lg">
      <p className="text-xs font-medium text-stone-500 mb-1">{label}</p>
      {payload.map((p, i) => (
        <p key={p.name || p.dataKey || i} className="text-sm font-semibold" style={{ color: p.color }}>
          {p.name}: {p.value}
        </p>
      ))}
    </div>
  );
};

export const TrendCharts = ({ chartData }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
    {/* Registration Trend */}
    <div className="bg-white border border-stone-200 rounded-2xl p-6" data-testid="registration-trends-chart">
      <div className="flex items-center gap-2 mb-4">
        <TrendingUp className="w-5 h-5 text-amber-600" />
        <h3 className="text-lg font-semibold text-stone-900">User Registrations (30 days)</h3>
      </div>
      {chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height={220}>
          <AreaChart data={chartData}>
            <defs>
              <linearGradient id="colorReg" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={AMBER} stopOpacity={0.3} />
                <stop offset="100%" stopColor={AMBER} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E7E5DF" />
            <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#57534E' }} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#57534E' }} />
            <Tooltip content={<ChartTooltip />} />
            <Area type="monotone" dataKey="registrations" name="Registrations" stroke={AMBER} fill="url(#colorReg)" strokeWidth={2} />
          </AreaChart>
        </ResponsiveContainer>
      ) : (
        <p className="text-sm text-stone-400 text-center py-10">No data for this period</p>
      )}
    </div>

    {/* Trip Trend */}
    <div className="bg-white border border-stone-200 rounded-2xl p-6" data-testid="trip-trends-chart">
      <div className="flex items-center gap-2 mb-4">
        <Activity className="w-5 h-5 text-emerald-700" />
        <h3 className="text-lg font-semibold text-stone-900">Trips Created (30 days)</h3>
      </div>
      {chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E7E5DF" />
            <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#57534E' }} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#57534E' }} />
            <Tooltip content={<ChartTooltip />} />
            <Bar dataKey="trips" name="Trips" fill={GREEN} radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <p className="text-sm text-stone-400 text-center py-10">No data for this period</p>
      )}
    </div>
  </div>
);
